import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  palette: {
    primary: {
      main: "#90b7b9",
      contrastText: "#fff",
    },
    secondary: {
      main: "#232725",
      contrastText: "#fff",
    },
  },
});

export default Theme;
